"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCategoryTree = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
const isEmpty_1 = require("../helper/isEmpty");
function trackCategoryTree(trackingPath, trackingName) {
    if (!trackingName && (0, isEmpty_1.isEmpty)(trackingPath)) {
        return;
    }
    const categoryPaths = (0, isEmpty_1.isEmpty)(trackingPath)
        ? []
        : [...trackingPath];
    if (trackingName) {
        categoryPaths.push(trackingName);
    }
    (0, pushToDataLayer_1.pushToDataLayer)({
        CategoryTree: categoryPaths.join(' > '),
    });
}
exports.trackCategoryTree = trackCategoryTree;
//# sourceMappingURL=trackCategoryTree.js.map